import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

const env = import.meta.env.VITE_APP_ENV;
if (env === 'production' || env === 'staging') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    environment: env
  });
}
